import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { BlogComponent } from './blog.component';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';



const routes: Routes = [
    {
        path: 'blog',
        component: BlogComponent,
        data: {
            permission: {
                only: ['role1', 'role2']
            }
        },
        canActivate: [AuthGuard, RoleGuard]
    }
];

@NgModule({
    imports: [
        SharedModule,
        RichTextEditorAllModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        BlogComponent
    ],
    entryComponents: [],
    providers: [
        AuthGuard, RoleGuard
    ]
})
export class BlogModule { }



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/blog/blog.module.ts